window.onload = function() {
  let cache = {};

  const $sample_atc_submit_event = async function ($form_data) {
    const $sample_addtocart_result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify($form_data),
    });

    const $atc_success_result = await $sample_addtocart_result.json();
    if ($atc_success_result.items) {
      if (
        document.querySelector("cart-drawer") &&
        document.querySelector("cart-drawer").classList.contains("is-empty")
      )
        document.querySelector("cart-drawer").classList.remove("is-empty");
      const quickAddModal = document.querySelector("quick-add-modal");

      if (quickAddModal) {
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              document
                .querySelector("cart-drawer")
                .renderContents($atc_success_result);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        document
          .querySelector("cart-drawer")
          .renderContents($atc_success_result);
      }
      flash("Product added!");
      // SlideCart.open();
      // load_cart();
    } else {
      console.error($atc_success_result);
    }
  };

  $(document).on(
    "change",
    ".subscription-plan__variant-options input[type=radio][name^=Color-]",
    function (e) {
      let $match = $(
        `variant-radios .product-form__input input[value="${$(this).val()}"]`
      );
      $match.prop("checked", true);
      $match[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  );

  $(document).on("click", ".trigger_btn", async function (e) {
    e.preventDefault(), e.stopImmediatePropagation();

    $(this).attr("disabled", true);
    $(".loading-overlay__spinner", this).removeClass("hidden");

    let selectedColor;
    let $match;
    let sample_product_atc_array;
    let vals;
    let $subscriptionPlan;
    let $subscriptionPlans;
    let mainProp;
    let subText;

    // BREAKPOINT HERE TO REACH THE CHECKED INPUT FOR DATA
    selectedColor = $(this)[0].parentElement.querySelector(
      "fieldset input:checked"
    ).value;
    $match = $(
      `variant-radios .product-form__input input[value="${selectedColor}"]`
    );
    $match.prop("checked", true);
    $match[0].dispatchEvent(new Event("change", { bubbles: true }));

    sample_product_atc_array = [];

    if ($(this).closest('.atc_btn_outer_identified').attr('data-id') == '7722316103838'){
      vals = $(this).closest(".atc_btn_outer_identified").find("fieldset input:checked").attr('data-var-id');
    }
    else{
      vals = $("#" + $(this).attr("form"))
      .find(".main_product_id")
      .val(); 
    }

    

    console.log(vals, ' vals');
    

    $subscriptionPlan = $(
      this.parentElement.parentElement.querySelector(
        ".plans-container input:checked"
      )
    );
    if (!$subscriptionPlan[0])
      $subscriptionPlan = $(
        this.parentElement.parentElement.querySelector(".plans-container input")
      );
    $subscriptionPlans = $(this).parents(".subscription-plans");

    mainProp = $subscriptionPlans
      .find(`variant-radios .product-form__input input:checked`)
      .data("vals");
    subText = $subscriptionPlan.data("property");

    let specialGift_Id = $subscriptionPlans
      .find(".special-gift-product")
      .attr("data-special-gift");
 
    let randomNumber = Math.random().toString().replace('0.','');
    let groupMatchingLine = selectedColor.replace(/ /g, "-").toLowerCase() + '-' + subText.toLowerCase() + '_' + randomNumber;

    if ($subscriptionPlan.data("value")) {
      if ($subscriptionPlan.data("selling-plan-id")) {
        var sellingPlanId = $subscriptionPlan.data("selling-plan-id");
      }
      sample_product_atc_array.push({
        id: vals,
        quantity: 1,
        properties: {
          _Product_Plan: mainProp,
          _subscription_plan: subText,
          _matching_line: groupMatchingLine,
        },
      });
      sample_product_atc_array.push({
        id: String($subscriptionPlan.data("value")),
        quantity: 1,
        properties: {
          _Product_Plan: mainProp,
          _subscription: $subscriptionPlan.data("sub"),
          _subscription_plan: subText,
          _product_design: pageType,
          _matching_line: groupMatchingLine,
        },
        selling_plan: String(sellingPlanId),
      });
    } else {
      sample_product_atc_array.push({
        id: vals,
        quantity: 1,
        properties: {
          _Product_Plan: mainProp,
          _subscription_plan: subText,
          _matching_line: groupMatchingLine,
        },
      });
    }

    if (specialGift_Id) {
      sample_product_atc_array.push({
        id: specialGift_Id,
        quantity: 1,
        properties: {
          _Product_Plan: mainProp,
          _subscription_plan: subText,
          _matching_line: groupMatchingLine,
        },
      });
    }

    let sample_product_atc_formData = {
      items: sample_product_atc_array,
      sections_url: window.location.pathname,
      sections: document
        .querySelector("cart-drawer")
        .getSectionsToRender()
        .map((section) => section.id),
    };

    sample_product_atc_formData.items.reverse();

    try {
      await $sample_atc_submit_event(sample_product_atc_formData);
    } catch (error) {
      console.error(error);
    } finally {
      $(this).removeAttr("disabled");
      $(".loading-overlay__spinner", this).addClass("hidden");
    }
  });
};
